// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_ni-2";
export var interactiveWrapper = "_ni-0";
export var shippingHoverPreview = "_ni-4";
export var summaryBadgeTrigger = "_ni-1";
export var widgetHoverPreviewList = "_ni-3";
export var widgetPreviewScale = "_ni-5";